<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="multi-level-table" :style="{ paddingTop: config.pageExplain ? '' : '20px' }" v-loading="!isAppenLiTable">
    <!-- <el-button @click="getAllTableData">保存</el-button> -->
    <el-scrollbar class="multi-level-table-navscroll" v-if="config.isAppenNav">
      <div class="multi-level-table-nav">
        <div class="nav-title" ref="navTitle" v-if="isConfig || config.isAppenNavExplain">
          <selectEdit v-if="isConfig">
            <i class="iconfont icon-bianji1" @click.stop="goEditNav"></i>
            <i class="iconfont icon-a-shanchu2x" @click.stop="config.navTitleConfig = {}"></i>
            <i class="iconfont" @click="$set(config, 'isAppenNavExplain', !config.isAppenNavExplain)" :class="config.isAppenNavExplain ? 'icon-guanbiyanjing' : 'icon-dakaiyanjing'"></i>
          </selectEdit>
          <styleModule :parentCustomData="customData" v-if="config.navTitleConfig" :dataInfo="config.navTitleConfig.styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config.navTitleConfig.bgSelect" />
        </div>
        <div class="nav-content">
          <div v-for="(item, idx) in config.rowNum" @click="changeTablePos(idx)" class="nav-content-item" :class="isActiveTable(idx) ? 'nav-content-active' : ''" :key="item">
            {{ item }}
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="multi-level-table-cc">
      <VueDraggableResizable :minH="60" @resizestop="resizeEnd" style="position: relative;width: 100%;" :draggable="false" :resizable="isConfig" class="multi-level-table-title" v-if="config.pageExplain" :handles="isConfig ? ['bm'] : []" :h="config.pageExplainHeight || 60">
        <div ref="titleInfo" class="multi-level-table-title-item">
          <selectEdit v-if="isConfig" @goEdit="editTableTitleAndHeader('title')" :isAppenDel="Boolean(config.titleInfo)" @goDel="delConfig('titleInfo')" />
          <styleModule v-if="config.titleInfo" :parentCustomData="customData" :dataInfo="config.titleInfo.styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config.titleInfo.bgSelect" />
        </div>
      </VueDraggableResizable>
      <template v-if="isAppenTable">
        <div class="multi-level-table-content" v-if="isAppenLiTable" :style="{ height: config.pageExplain ? `calc(100% - ${(config.pageExplainHeight || 60) + 40}px)` : '100%' }">
          <template v-for="(item, index) in (config.singleColNum || 1)" :key="index">
            <!-- 由于自定义的逻辑和之前的逻辑完全不一样，所以重新写 -->
            <template v-if="config.optionsMenthods === 'custom'">
              <customTable :customData="customData" :appInfo="appInfo" :queryData="queryData" :btnContainer="btnContainer(index)" :allRows="allRows" :rowLen="rowSplitTrees.length" :pageInfo="pagesInfo[index]" :isConfig="isConfig" class="table-content" ref="customTable" @changePage="changePage" :idx="index" :isAppenAll="config.isAppenAll" :columns="columns(index)" :rows="rows(index)" :config="config" @openEdit="editTableTitleAndHeader('header', index)" @delConfig="delConfig" @editRow="editRow" />
            </template>
            <template v-else>
              <batchTable :customData="customData" :queryData="queryData" :btnContainer="btnContainer(index)" :allRows="allRows" :rowLen="rowSplitTrees.length" :pageInfo="pagesInfo[index]" :isConfig="isConfig" class="table-content" ref="batchTable" @changePage="changePage" :idx="index" :isAppenAll="config.isAppenAll" :columns="columns(index)" :rows="rows(index)" :config="config" @openEdit="editTableTitleAndHeader('header', index)" @delConfig="delConfig" @editRow="editRow" />
            </template>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="no-data">
          <img class="noCustomImg" src="https://bigdata.topeti.com/PCRepository/mainPlatform/Intersect.png" alt="">
          <div class="noCustomTextTwo">请设置行表头或列表头</div>
        </div>
      </template>
      <editStyle ref="editStyle" title="编辑图片样式" :customData="customData" @on-success="confirmEdit" :modelW="`${editStyleReact.width}px`" :modelH="`${editStyleReact.height}px`" />
    </div>
  </div>
</template>
  
<script>
import selectEdit from '../common/selectEdit.vue';
import editStyle from '@/components/common/editStyle/index.vue';
import styleModule from '@/components/schoolInstrument/common/styleModule.vue'
import VueDraggableResizable from 'vue3-draggable-resizable'
import batchTable from './batchTable'
import customTable from './customTable.vue';

import { cloneDeep, isEmpty } from 'lodash';
import { setThreeData, splitTreeByLeavesCount, importData, strToObject, defaultValuesForParameterTransmission } from '@/components/admins/workBench/moreSetting/mycomponent/batchAddition/utils.js'

export default {
  name: 'MultiLevelTable',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    appInfo: {
      type: Object,
      default: () => ({})
    },
    isConfig: {
      type: Boolean,
      default: true
    },
    queryData:{
      type: Object,
      default: () => ({})
    },
    customData: {
      type: Array,
      default: () => []
    },
    property: {
      type: Array,
      default: ()=>([])
    }
  },
  components: {
    selectEdit,
    editStyle,
    styleModule,
    batchTable,
    VueDraggableResizable,
    customTable,
  },
  data() {
    return {
      openType: '',
      tempRowId: '',
      editStyleReact: {
        width: 100,
        height: 100
      },
      colSplitTrees: [],
      rowSplitTrees: [],
      allRows: [],
      isAppenLiTable: false,
      pagesInfo: {}
    }
  },
  computed: {
    isAppenTable() {
      if(!isEmpty(this.config.colInfo) && !isEmpty(this.config.rowInfo)) return true
      else return false
    },
    customTableData() {
      const refs = this.$refs.customTable
      if (refs && refs[0]) {
        return refs[0].tableData
      } else {
        return {}
      }
    }
  },
  watch: {
    'config.optionsMenthods': {
      handler(val, oldVal) {
        if (oldVal === 'custom' || val === 'custom') {
          this.initTree()
        }
      },
      deep: true
    }
  },
  async mounted () {
   await this.initTree()
  },
  methods: {
    isActiveTable(idx) {
      const refs = this.$refs.customTable
      if (refs && refs[0]) {
        const tableData = refs[0].tableData
        let flag = false
        for (const key in tableData) {
          const val = tableData[key]
          if (Number(key.split('-')[0]) === idx) {
            if (Array.isArray(val) && val.length > 0) {
              flag = true
              break
            } else if (val) {
              flag = true
              break
            }
          }
        }
        return flag
      } else {
        return  false
      }
    },
    changeTablePos(idx) {
      const refs = this.$refs.customTable
      if (refs && refs[0]) {
        const ref = refs[0]
        ref.goScrollPos(idx)
      }
    },
    goEditNav() {
      const config = this.config.navTitleConfig || {}
      this.openType = 'navTitleConfig'
      const rect = this.$refs.navTitle.getBoundingClientRect()
      const { styleInfo, bgSelect = '' } = config
      this.editStyleReact = rect
      this.$nextTick(() => {
        this.$refs.editStyle.open(styleInfo, { bgSelect })
      })
    },
    btnContainer(idx) {
      const pageInfo = this.pagesInfo[idx]
      if (pageInfo) {
        const { col, row, isChangeRow } = pageInfo
        const left = col > 1
        const right = col < this.rowSplitTrees.length
        let top = false
        let bottom = false
        if (isChangeRow) {
          top = row > 1
          bottom = row < this.colSplitTrees.length
        } else {
          top = idx > 0
          bottom = idx < this.colSplitTrees.length - 1
        }
        return { left, right, top, bottom }
      } else {
        return {}
      }
    },
    clearTable() {
      if (this.config.optionsMenthods === 'custom') {
        const customTables = this.$refs.customTable
        for (const ref of customTables) {
          ref.initTableData(true)
        }
      } else {
        const batchTables = this.$refs.batchTable || []
        for (const ref of batchTables) {
          ref.initTableData(true)
        }
      }
    },
    changePage({ idx, type }) {
      const { col, row } = this.pagesInfo[idx]
      if (['left', 'right'].includes(type)) {
        // 左右翻页
        if (type === 'left' && col > 1) {
          this.pagesInfo[idx].col--
        } else if (type === 'right' && col < this.rowSplitTrees.length) {
          this.pagesInfo[idx].col++
        }
      } else if (['top', 'bottom'].includes(type)) {
        // 上下翻页
        if (this.pagesInfo[idx] && !this.pagesInfo[idx].isChangeRow) {
          this.pageInfos[idx].isChangeRow = true
        }
        if (type === 'top' && row > 1) {
          this.pagesInfo[idx].row--
        } else if (type === 'bottom' && row < this.colSplitTrees.length) {
          this.pagesInfo[idx].row++
        }
      }
    },
    resizeEnd(x, y, width, height) {
      // eslint-disable-next-line vue/no-mutating-props
      this.config.pageExplainHeight = height
    },
    async getSplitTrees(key) {
      if (this.config && this.config[key]) {
        const headerConfg = this.config[key].headerConfg
        const config = this.config
        const treeData = await setThreeData({ headerConfg, customData: this.customData, config, isCustom: this.config.optionsMenthods !== 'custom' })
        console.log(treeData,'treeData');
        
        return treeData
      } else {
        return []
      }
    },
    async initTree () {
      if (this.config) {
        const config = this.config
        const infoArr = ['colInfo', 'rowInfo']
        for (let index = 0; index < infoArr.length; index++) {
          const key = infoArr[index];
          let customData = this.customData
          if (this.queryData.search) {
            let search = typeof this.queryData.search === 'string' ? JSON.parse(this.queryData.search) : this.queryData.search
            for (const ele of customData) {
              const key = `${ele.title}_${ele.type}_${ele.name}`
              if (search[key]) {
                ele.value = search[key]
              }
            }
          }
          if (this.config[key] && this.config[key].headerConfg) {
            const headerConfg = cloneDeep(this.config[key].headerConfg)
            const treeData = await setThreeData({ headerConfg, customData, config, isCustom: this.config.optionsMenthods !== 'custom' })
            if (key === 'colInfo') {
              this.allRows = treeData
            }
            if (this.config.optionsMenthods === 'custom') { 
              let setKey = 'colSplitTrees'
              let splitNum = this.config.rowNum
              if (key === 'rowInfo') {
                setKey = 'rowSplitTrees'
                splitNum = this.config.colNum
              }
              const len = treeData.length
              let tree = []
              if (len > splitNum) {
                tree = splitTreeByLeavesCount(treeData, this.config.rowNum)
              } else {
                tree = [treeData]
              }
              this[setKey] = tree
            } else {
              const splitNum = key === 'colInfo' ? this.config.rowNum : this.config.colNum
              this.setSplitTrees(treeData, key, splitNum)
            }
          }
        }
        this.isAppenLiTable = true
        this.$nextTick(() => {
          for (const ref of (this.$refs.batchTable || [])) {
            if (ref) {
              ref.initTableData()
            }
          }
        })
      }
    },
    setSplitTrees(treeData, key, splitNum) {
      console.log(key ,treeData , splitNum,'key && treeData && splitNumasdsad');
      
      if (key && treeData && splitNum) {
        const splitTrees = splitTreeByLeavesCount(cloneDeep(treeData), splitNum)
        const setKey = key === 'colInfo' ? 'colSplitTrees' : 'rowSplitTrees'
        this[setKey] = splitTrees
      }
    },
    rows(idx) {
      if (this.config.colInfo) {
        const pageInfo = this.pagesInfo[idx]
        if (pageInfo) {
          const { row, isChangeRow } = pageInfo
          if (row && isChangeRow) {
            return this.colSplitTrees[row - 1] || []
          } else {
            this.pagesInfo[idx].row = 1
            return this.colSplitTrees[idx] || []
          }
        } else {
          this.pagesInfo[idx] = { col: 1, row: 1, isChangeRow: false }
          return this.colSplitTrees[idx] || []
        }
      } else {
        return []
      }
    },
    columns(idx) {
      if (this.config.rowInfo) {
        const pageInfo = this.pagesInfo[idx]
        if (pageInfo) {
          const { col } = pageInfo
          if (col) {
            return this.rowSplitTrees[col - 1] || []
          } else {
            this.pagesInfo[idx].col = 1
            return this.rowSplitTrees[0] || []
          }
        } else {
          this.pagesInfo[idx] = { col: 1, row: 1, isChangeRow: false }
          return this.rowSplitTrees[0] || []
        }
      } else {
        return []
      }
    },
    delConfig(key) {
      const obj = cloneDeep(this.config)
      delete obj[key]
      this.$emit('update:config', obj)
    },
    getAllTableData() {
      const list = []
      if (this.config.optionsMenthods === 'custom') {
        for (const ref of this.$refs.customTable) {
          const [li, stop] = this.getCustomTableData(ref)
          if (stop) return [[], true]
          list.push(...li)
        }
      } else {
        for (const ref of this.$refs.batchTable) {
          const li = this.getTableData(ref)
          list.push(...li)
        }
      }
      return [list, false]
    },
    getCustomTableData(ref) {
      if (!ref) return
      const li = []
      const rowNum = this.config.rowNum
      const colNum = this.config.colNum
      const processedRows = ref.processedRows
      const processedHeaders = ref.processedHeaders[0]
      const cellConfig = this.config.cellConfig
      let paramsList = this.queryData.paramsList || []
      if (paramsList && !Array.isArray(paramsList)) {
        paramsList = JSON.parse(paramsList)
      }
      for (let i = 0; i < rowNum; i++) {
        for (let j = 0; j < colNum; j++) {
          const key = `${i}-${j}`
          const value = ref.tableData[key]
          const config = cellConfig[key] || {}
          const required = config.required
          // 单选和星星
          if ((required && !value) || (config.type === 'checkbox' && Array.isArray(value) && value.length === 0 && required)) {
            this.$message.error('请填写正确的内容')
            this.changeTablePos(i)
            return [[], true]
          }
          if (value) {
            let otherParam = {} // 其他字段值
            const colParams = {} // 列的字段值
            const rowParams = {} // 行的字段值
            if (this.config.isAppenCol) {
              // 出现列表头
              const row = processedRows[i]
              if (row) {
                row.path.forEach((header) => {
                  const targetField = header.targetField
                  const val = header.value
                  if (targetField && targetField.title) {
                    const key = `${targetField.title}_${targetField.type}_${targetField.name}`
                    colParams[key] = val
                  }
                })
              }
            }
            if (this.config.isAppenRow) {
              const col = processedHeaders[j]
              if (col) {
                const idxLi = col.dataIndex.split('')
                processedHeaders.forEach((process, processIdx) => {
                  const data = process[idxLi[processIdx]]
                  const key = data.key
                  const value = data.value
                  if (key) {
                    rowParams[key] = value
                  }
                })
              }
            }
            if (config.type === 'checkbox') {
              // TODO
            } else {
              const ci = config.config.find(item => item.name === value)
              if (ci) {
                const paramsLi = ci.parameter.filter(item => item.inputType === 'variable')
                const customLi = ci.parameter.filter(item => item.inputType === 'custom')
                const customTitle = ci.parameter.filter(item => item.inputType === 'customTitle')
                const customContent = ci.parameter.filter(item => item.inputType === 'customContent')
                for (const ele of customLi) {
                  const key = ele.conditionValue
                  otherParam[key] = ele.value
                }
                for (const ele of paramsLi) {
                  if (ele.value) {
                    const [name, title] = ele.value.split('_')
                    const param = paramsList.find(ele => ele.name === name)
                    const key = ele.conditionValue
                    if (param) {
                      otherParam[key] = param.value
                    } else {
                      const custom = this.customData.find(f => f.title === title)
                      otherParam[key] = custom ? custom.value : ''
                    }
                  }
                }
                for (const ele of customTitle) {
                  const key = ele.conditionValue
                  otherParam[key] = config.customTitle
                }
                for (const ele of customContent) {
                  const key = ele.conditionValue
                  otherParam[key] = ci.name
                }
              }
            }
            const param = Object.assign({}, otherParam, colParams, rowParams)
            li.push(param)
          }
        }
      }
      return [li, false]
    },
    getTableData(ref) {
      if (!ref) return
      const li = []
      const allTableData = ref.tableData
      const rows = ref.processedAllRows
      const cols = ref.leafColumns
      // 表格的选项
      const optionsMenthods = this.config.optionsMenthods
      const processedHeaders = ref.processedHeaders
      let paramsList = this.queryData.paramsList || []
      if (paramsList && !Array.isArray(paramsList)) {
        paramsList = JSON.parse(paramsList)
      }
      // 输入框对应的key
      let inputKey = ''
      let totalFiled = {}
      if (this.config.singleConfig && optionsMenthods !== 'select'){
        const customize = cloneDeep(this.config.singleConfig.customize || [])
        const customLi = customize.filter(ele => ele.type !== 'variable')
        const variable = customize.filter(ele => ele.type === 'variable')
        inputKey = this.config.singleConfig.info.inputKey
        for (const ele of customLi) {
          if (ele.condition === 'eq') {
            const key = ele.conditionValue
            totalFiled[key] = ele.value
          }
        }
        for (const ele of variable) {
          if (ele.condition === 'eq' && ele.value) {
            const [name] = ele.value.split('_')
            const param = paramsList.find(ele => ele.name === name)
            if (param) {
              const key = ele.conditionValue
              totalFiled[key] = param.value
            } else {
              const key = ele.conditionValue
              const custom = this.customData.find(f => f.name === name)
              if (custom) {
                totalFiled[key] = custom.value
              }
            }
          }
        }
      }
      
      for (const key in allTableData) {
        const tableData = allTableData[key]
        rows.forEach((row) => {
          cols.forEach((col, colIndex) => {
            let param = {}
            let val = null
            let flag = false
            const dataId = row.dataId
            if (optionsMenthods === 'radio') {
              val = tableData[dataId]
              if (val !== '') {
                flag = Number(val) === colIndex
              }
            } else if (optionsMenthods === 'input') {
              val = tableData[dataId][colIndex]
              flag = true
            } else {
              val = tableData[dataId][colIndex]
              flag = Boolean(val)
            }
            if (flag) {
              const colParams = {}
              row.path.forEach((header) => {
                const targetField = header.targetField
                const value = header.value
                if (targetField) {
                  const key = `${targetField.title}_${targetField.type}_${targetField.name}`
                  colParams[key] = value
                }
                if (optionsMenthods === 'input' && inputKey) {
                  colParams[inputKey] = val
                }
              })
              const rowParams = {}
              const dataIndex = processedHeaders[processedHeaders.length - 1][colIndex].dataIndex
              const idxLi = dataIndex.split('')
              processedHeaders.forEach((process, processIdx) => {
                const data = process[idxLi[processIdx]]
                const key = data.key
                const value = data.value
                if (key) {
                  rowParams[key] = value
                }
                if (optionsMenthods === 'input' && inputKey) {
                  rowParams[inputKey] = val
                }
              })
              if (optionsMenthods === 'select' && this.config.optionsConfig) {
                const config = this.config.optionsConfig.config || []
                const ci = config.find(item => item.name === val)
                if (ci) {
                  const paramsLi = ci.parameter.filter(item => item.inputType === 'variable')
                  const customLi = ci.parameter.filter(item => item.inputType === 'custom')
                  for (const ele of customLi) {
                    const key = ele.conditionValue
                    totalFiled[key] = ele.value
                  }
                  for (const ele of paramsLi) {
                    if (ele.condition === 'eq' && ele.value) {
                      const [name] = ele.value.split('_')
                      const param = paramsList.find(ele => ele.name === name)
                      if (param) {
                        const key = ele.conditionValue
                        totalFiled[key] = param.value
                      }
                    }
                  }
                }
              }
              param = Object.assign({}, rowParams, colParams, totalFiled)
              li.push(param)
            }
          })
        })
      }
      return [li, false]
    },
    async submit(params = {}, msg = '新增成功'){
      let [data, isStop] = this.getAllTableData()
      // 是否有必填没填
      if (isStop) return
      let isIncludesDetail = false
      const fileProperty = this.appInfo.fileProperty || {}
      for (const key in fileProperty) {
        const ele = fileProperty[key]
        if (ele.type.includes('details')) {
          isIncludesDetail = true
        }
      }
      let search = this.queryData.search
      let query = {}
      if (search) {
        search = strToObject(search)
        for (const key in search) {
          const [title] = key.split('_') 
          const filed = fileProperty[title]
          query[`${key}_${filed.name}`] = search[key]
        }
      }

      // 要是后台改好了 这边注释
      const dataList = []
      for (const item of data) {
        let value = { ...params, ...item, ...query }
        const formdata = defaultValuesForParameterTransmission(this.property, value, true)
        const foemdata = cloneDeep(formdata)
        for (const key in foemdata) {
          const ele = foemdata[key]
          if (!ele) {
            delete formdata[key]
          } else if (ele && Array.isArray(ele) && (ele.length === 0 || !ele[0])) {
            delete formdata[key]
          } else if (ele && typeof ele === 'object' && Object.keys(ele).length === 0) {
            delete formdata[key]
          }
        }
        dataList.push(formdata)
      }
      await importData(dataList, { approvalId: this.appInfo.id, isIncludesDetail, msg })
    },
    editCol() {
      
    },
    editRow(obj = {}) {
      const { id, react } = obj
      this.openType = 'row'
      this.tempRowId = id
      const config = this.config[id] || {}
      const { styleInfo, bgSelect = '' } = config
      this.editStyleReact = react
      this.$nextTick(() => {
        this.$refs.editStyle.open(styleInfo, { bgSelect })
      })
    },
    confirmEdit(val, opt = {}) {
      const type = this.openType
      if (type === 'title' || type === 'header') {
        const infoKey = `${type}Info`
        const obj = {
          styleInfo: val,
          bgSelect: opt.bgSelect,
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.config[infoKey] = obj
      } else if (type === 'row') {
        const id = this.tempRowId
        const obj = {
          styleInfo: val,
          bgSelect: opt.bgSelect,
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.config[id] = obj
      } else if (type === 'navTitleConfig') {
        const id = 'navTitleConfig'
        const obj = {
          styleInfo: val,
          bgSelect: opt.bgSelect,
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.config[id] = obj
      }
    },
    editTableTitleAndHeader(type = 'title', index) {
      const infoKey = `${type}Info`
      let ref = this.$refs[infoKey]
      if (type === 'header') {
        ref = this.$refs.batchTable[index].$refs[infoKey]
      }
      const config = this.config[infoKey] || {}
      const { styleInfo, bgSelect = '' } = config
      Array.isArray(ref) && (ref = ref[0])
      const react = ref.getBoundingClientRect()
      this.editStyleReact = react
      this.openType = type
      this.$nextTick(() => {
        this.$refs.editStyle.open(styleInfo, { bgSelect })
      })
    },
  },
}
</script>

<style scoped lang="scss">

.multi-level-table {
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  &-nav {
    display: flex;
    flex-direction: column;
  }
  &-navscroll {
    width: 300px;
    margin-right: 20px;
    height: fit-content;
    border: 1px solid #ECECEC;
    height: 100%;
    .nav-title {
      height: 50px;
      position: relative;
      width: 100%;
      .icon-guanbiyanjing {
        margin-left: 10px;
        font-size: 16px !important;
      }
      .icon-dakaiyanjing {
        font-size: 12px !important;
        margin-left: 10px;
      }
    }
    .nav-content {
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      &-item {
        width: 40px;
        height: 32px;
        margin-right: 4px;
        margin-bottom: 4px;
        border-radius: 4px;
        background-color: #F2F2F3;
        border: 1px solid #E2E2E2;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        color: #333333; 
        &:nth-of-type(6n) {
          margin-right: 0;
        }
      }
      &-active {
        background-color: #E3F9EE;
        border: 1px solid #76DFA3;
        color: #3FBB3C;
      }
    }
  }
  &-cc {
    flex: 1;
  }
  ::v-deep &-title {
    height: 60px;
    width: 100%;
    margin: 20px 0;
    position: relative;
    background-color: transparent;
    &-item {
      width: 100%;
      height: 100%;
    }
    .handle-bm {
      width: 8px !important;
      height: 8px !important;
      border-radius: 100%;
      background-color: #4e86ff;
      opacity: 1;
      margin-right: 0;
      border: none;
      bottom: -5px !important;
    }
  }
  &-content {
    display: flex;
    .table-content {
      margin-right: 10px;
      flex: 1;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .noCustomImg {
      margin: 0 auto;
      display: inline-block;
      width: 106px;
      height: 99px;
    }
    .noCustomTextTwo {
      margin: 16px auto 0;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 16px;
      opacity: 0.45;
    }
  }
}
</style>